import React, { useState } from "react";
import { Link } from "gatsby";
import {
  FaRegListAlt,
  FaHome,
  FaChartBar,
  FaIdBadge,
  FaRegCalendarAlt,
  FaArrowLeft,
  FaFutbol,
  FaChevronDown,
  FaBookOpen,
} from "react-icons/fa/";

import { seasons, currentSeasonId } from "../util/seasons";

const MenuItem = ({ path, closeMenu, children }) => (
  <Link
    to={path}
    onClick={closeMenu}
    className="block w-full border-0 border-b border-gray-200 dark:border-line-dark pt-8 no-underline"
    activeClassName="bg-violet-tint dark:bg-white/5"
  >
    {children}
  </Link>
);

const MenuName = ({ children, Icon = null }) => (
  <div className="m-1 ml-8 flex text-gray-900 dark:text-white">
    {Icon && (
      <div className="h-8 w-8 pt-1">
        <Icon className="fill-violet dark:fill-[#B79CE8]" />
      </div>
    )}
    {children}
  </div>
);

const SeasonsMenuItem = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-0 border-b border-gray-200 dark:border-line-dark pt-8">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between"
      >
        <MenuName Icon={FaArrowLeft}>Sezonlar</MenuName>
        <FaChevronDown
          className={`fill-violet dark:fill-[#B79CE8] mr-8 w-3 h-3 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <div className="flex flex-col">
          {seasons.map((season) =>
            season.id === currentSeasonId ? (
              <span
                key={season.id}
                className="m-1 ml-16 mb-4 font-semibold text-gold"
              >
                {season.label}
              </span>
            ) : (
              <a
                key={season.id}
                href={season.url}
                target="_blank"
                rel="noreferrer"
                className="m-1 ml-16 mb-4 text-gray-900 dark:text-white"
              >
                {season.label}
              </a>
            )
          )}
        </div>
      )}
    </div>
  );
};

const MenuBar = (props) => {
  return (
    <div className="lg:hidden h-full w-full mt-8">
      <div className="flex z-10 flex-col w-full bg-white font-bold dark:bg-surface-dark pt-20">
        <MenuItem path="/" {...props}>
          <MenuName Icon={FaHome}>Ana Sayfa</MenuName>
        </MenuItem>
        <MenuItem path="/sezon-ozeti/" {...props}>
          <MenuName Icon={FaBookOpen}>Sezon Özeti</MenuName>
        </MenuItem>
        <MenuItem path="/takim-istatistikleri/" {...props}>
          <MenuName Icon={FaChartBar}>Takım İstatistikleri</MenuName>
        </MenuItem>
        <MenuItem path="/fikstur/" {...props}>
          <MenuName Icon={FaRegCalendarAlt}>Fikstür ve Sonuçlar</MenuName>
        </MenuItem>
        <MenuItem path="/puan-durumu/" {...props}>
          <MenuName Icon={FaRegListAlt}>Puan Durumu</MenuName>
        </MenuItem>
        <MenuItem path="/lig-liderleri/" {...props}>
          <MenuName Icon={FaFutbol}>Lig Liderleri</MenuName>
        </MenuItem>
        <MenuItem path="/hakemler/" {...props}>
          <MenuName Icon={FaIdBadge}>Hakemler</MenuName>
        </MenuItem>
        <SeasonsMenuItem />
      </div>
    </div>
  );
};

export default MenuBar;
